module.exports = __webpack_public_path__ + "static/media/snappy-idea.4bd8ac5d.svg";